// extracted by mini-css-extract-plugin
module.exports = {"loading":"ProgressiveImg_loading__2mxTE","loaded":"ProgressiveImg_loaded__1OsI-"};